import React, {useEffect, useState} from "react";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import {useCalcContext} from "../../contexts/CalcContext";
import Radio from "@mui/material/Radio";
import {useUserContext} from "../../contexts/UserContext";
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import Stack from "@mui/material/Stack";
import {LocationModal} from "../DealPage/LocationModal";
import {useModalsStore} from "../../stores/modalsStore";
import classnames from "classnames";
import {buildLocationString, parseGoogleAddressData} from "../../utils/utils";
import Autocomplete from "react-google-autocomplete";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {useDefaultQuoteSettingsContext} from "../../contexts/DefaultQuoteSettingsContext";


const SelectLocationItem = (props) => {
    const {
        location,
        selectedLocation,
        handleLocationChange,
    } = props

    const isSelected = Boolean(location.id === selectedLocation.id)

    return (
        <Typography
            className={classnames('location-item', {
                selected: isSelected
            })}
        >
            <Radio
                checked={isSelected}
                onChange={() => handleLocationChange(location)}
                value={location}

            />
            <span>{buildLocationString(location)}</span>
        </Typography>
    )
}

const SelectLocationItemZipInput = (props) => {
    const {
        location,
        setLocation,
        handleLocationChange,
        selectedLocation,
    } = props

    const [inputValue, setInputValue] = useState(() => buildLocationString(location))

    const isChecked = Boolean(
        location && selectedLocation &&
        `${selectedLocation.city}${selectedLocation.county}${selectedLocation.state}${selectedLocation.zip}` ===
        `${location.city}${location.county}${location.state}${location.zip}`
    )

    return (
        <Typography
            className={'location-item'}
        >
            <Radio
                disabled={!Boolean(location)}
                checked={location && isChecked}
                onChange={() => handleLocationChange(location)}
                value={location || ''}
            />
                <Autocomplete
                    placeholder={`Enter 5-digit zipcode`}
                    className={classnames('CreateLocationInput_input', {
                        disabled: false
                    })}
                    onChange={(e) => setInputValue(e.target.value)}
                    style={{
                        zIndex: "inherit",
                        width: "280px",
                        border: 'none',
                        outline: 'none'
                    }}
                    value={inputValue}
                    inputAutocompleteValue={buildLocationString(location)}
                    apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
                    onPlaceSelected={(place) => {
                        const parsed = parseGoogleAddressData(place.address_components)
                        setInputValue(buildLocationString(parsed))
                        setLocation(parsed)
                        handleLocationChange(parsed)
                    }}
                    options={{
                        types: ['postal_code'], // Restrict suggestions to postal codes only
                        componentRestrictions: { country: 'us' }, // Restrict to a specific country (e.g., US)
                        fields: ['address_components', 'name'] // Request only necessary data fields to control billing
                    }}
                />
        </Typography>
    )
}


export const CalcPageSelectLocation = () => {
    const { profileState } = useUserContext()
    const { quoteSettings } = useDefaultQuoteSettingsContext()
    const [tab, setTab] = useState('Customer');
    const isCustomerTab = tab === 'Customer'
    const openModal = useModalsStore((state) => state.openModal)
    const [customerZipLocation, setCustomerZipLocation] = useState(null)
    const [dealerZipLocation, setDealerZipLocation] = useState(null)

    const {
        calcState,
        setCalcState,
        saveLocation,
    } = useCalcContext()

    const defaultLocation = quoteSettings.customer_location
    const selectedLocation = isCustomerTab ? calcState.location : calcState.dealer_location
    const pinnedLocations = profileState.pinned_locations
    const displayedLocations = [defaultLocation, ...pinnedLocations]
    const displayedLocationIds = displayedLocations.map(l => l.id)
    const hasZipLocation = isCustomerTab ? Boolean(customerZipLocation) : Boolean(dealerZipLocation)
    const shouldDisplaySelectedLocation = !displayedLocationIds.includes(selectedLocation.id) && !hasZipLocation

    return (
        <Box className={'CalcPageInfo_box'}>
            <Stack
                direction="column"
                justifyContent="space-between"
                style={{
                    height: '100%'
                }}
            >
                <div>
                    <Typography
                        variant="h6"
                        component="div"
                        className={'header location-info'}
                    >
                        <LocationOnOutlinedIcon sx={{color: '#2267CE'}}/>
                        <span>
                            Location Selection
                        </span>
                    </Typography>
                    <Divider className={'divider'} />

                    {
                        false &&
                        <React.Fragment>
                            <Tabs
                                value={tab}
                                onChange={(e, tab) => setTab(tab)}
                                aria-label="basic tabs example"
                                variant="fullWidth"
                            >
                                <Tab
                                    label="Customer"
                                    value={'Customer'}
                                    sx={{
                                        borderRadius: "4px 0 0 4px",
                                    }}
                                    className={classnames('location-tab', {
                                        selected: tab === 'Customer'
                                    })}
                                />
                                <Tab
                                    label="Dealer"
                                    value={'Dealer'}
                                    sx={{
                                        borderRadius: "0 4px 4px 0",
                                    }}
                                    className={classnames('location-tab', {
                                        selected: tab === 'Dealer'
                                    })}
                                />
                            </Tabs>
                            <Divider className={'divider'}/>
                        </React.Fragment>
                    }
                    {
                        isCustomerTab &&
                        <SelectLocationItemZipInput
                            selectedLocation={selectedLocation}
                            location={customerZipLocation}
                            setLocation={setCustomerZipLocation}
                            handleLocationChange={(location) => saveLocation(location, true, true)}
                        />
                    }
                    {/*{*/}
                    {/*    !isCustomerTab &&*/}
                    {/*    <SelectLocationItemZipInput*/}
                    {/*        selectedLocation={selectedLocation}*/}
                    {/*        location={dealerZipLocation}*/}
                    {/*        setLocation={setDealerZipLocation}*/}
                    {/*        handleLocationChange={(location) => saveLocation(location, false, true)}*/}
                    {/*    />*/}
                    {/*}*/}
                    {
                        shouldDisplaySelectedLocation &&
                            <SelectLocationItem
                                location={selectedLocation}
                                selectedLocation={selectedLocation}
                                handleLocationChange={(location) => saveLocation(location, true, true)}
                            />
                    }
                    <div className={'Pinned-locations-container'}>
                    {
                        displayedLocations.map(
                            (location) => {
                                return (
                                    <SelectLocationItem
                                        key={location.id}
                                        location={location}
                                        selectedLocation={selectedLocation}
                                        handleLocationChange={(location) => saveLocation(location, true, true)}
                                    />
                                )
                            }
                        )
                    }
                </div>
                </div>

                <Button
                    className={''}
                    style={{
                        background: '#2267CE',
                        alignSelf: 'flex-end',
                    }}
                    onClick={() => {
                        openModal({
                            element: LocationModal,
                            id: "LocationModal",
                            props: {
                                selectLocation: saveLocation,
                            }
                        })
                    }}
                >
                    Edit
                </Button>
            </Stack>
        </Box>
    )
}